import  * as outline from './outlineId.js';
import  * as outlineXQ from './outlineXiangQ.js';
import  * as AddHistory from './HKActions.js';

export default  {
	hk: AddHistory,
    outlineId: outline,
    outlineXQ: outlineXQ
};